import styled from "styled-components";

export const RatingBadge = styled.span`
  padding: 8px;
  border-radius: 8px;
  color: #fff;
  background-color: #005709;
  filter: ${(props) => `brightness(${1.65 - props.value / 5})`};
`;
